import React from 'react';

import { StyledLineSeparator } from './styled';

const LineSeparator = ({ show }) => {
  return <StyledLineSeparator show={show} />;
};

export { LineSeparator };
